import { cineamoApiClient as apiClient } from '../../apiClient';
import { CartDto } from '../../models/cart/CartDto.types';
import { CartConcessionInputDto } from '../../models/cart-concession/CartConcessionDto.types';
import { ApiError } from '../../types/ApiErrorResponse.types';
import { CartConcessionListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

const cartSession = (cartUuid: CartDto['uuid']) => ({
    session: { scheme: 'CineamoCart' as const, accessToken: cartUuid }
});

/** Returns the concession lines of a cart; `null` when the request fails (e.g. 403 sale disabled). */
export async function getCartConcessions(
    cartUuid: CartDto['uuid']
): Promise<ApiResponse<CartConcessionListResponse> | null> {
    return apiClient
        .get<ApiResponse<CartConcessionListResponse>>(`/carts/${cartUuid}/concessions`, cartSession(cartUuid))
        .then((response) => response.data)
        .catch(() => null);
}

/**
 * Replaces all concession lines of a cart. Lines with `quantity` 0 are removed.
 * Fails with 400 `parameters.cinemaProductId.{isUnknown|notSameCinema|isInactive}` and with 403 when the
 * cinema does not sell concessions or the cart is paid (`reason_code: cart_is_paid`).
 */
export async function setCartConcessions(
    cartUuid: CartDto['uuid'],
    items: CartConcessionInputDto[]
): Promise<ApiResponse<CartConcessionListResponse> | ApiError> {
    return apiClient
        .put(`/carts/${cartUuid}/concessions`, { items }, cartSession(cartUuid))
        .then((response) => response.data)
        .catch((error) => error);
}
